<v-layout  class="w-100">
  <v-sheet
  width="100%"
  >
    <v-card flat  max-height="100%">
      <div v-if="!isProgressLoader">
        <!-- <VTour :name="tourName" :steps="tourSteps" ref="chatTour" saveToLocalStorage='step'></VTour> -->
      <v-card-title
        class="text-center overflow-visible py-1 position-fixed top-0 left-0 right-0 zi-9999 bg-primary"
        v-show="ActiveComponent!='AIChatBot' && ActiveComponent !='Home' && !IsHideHeadSection "
        :class="ActiveComponent == 'Help' || ActiveComponent == 'ChatHistory' ? 'pb-4' : ''"
      >
        <div
          class=""
          :class="ActiveComponent =='UserLogin'? 'text-end' : 'd-flex justify-space-between align-center'"
        >
        <div class="d-flex align-center justify-center text-center">
          <!-- <v-btn variant="text" v-if="ActiveComponent !='UserLogin'" size="30" @click="NavigateToHome" rounded aria-label="Back to Home">
            <v-icon class="fs-24px" role="img" aria-hidden="true"
            >mdi-chevron-left</v-icon
          >
          </v-btn> -->
          <div v-if="ActiveComponent=='News' || ActiveComponent=='Help' || ActiveComponent=='ChatHistory'"
          class="fs-18px font-weight-medium text-white py-2"
        >
          {{ActiveComponent=='Help' ? 'Help' : ActiveComponent=='News' ? 'News' : 'Chat History'}}
        </div>
        </div>
        
        <v-btn variant="text" size="30"  @click="closeDialog('Close')" rounded aria-label="Close chat box">
          <v-icon class="fs-24px" role="img" aria-hidden="true"
          >mdi mdi-close-circle</v-icon
        >
        </v-btn>
        </div>

        <v-text-field
          @input="handleSearch"
          :loading="isSearching"
          v-model="search"
          append-inner-icon="mdi-magnify opacity-1"
          class="bg-white rounded-lg border-0"
          :placeholder="ActiveComponent=='ChatHistory'  ? 'Search your chats...':'Search for help...'"
          variant="outlined"
          density="compact"
          hide-details="auto"
          ref="searchinputref"
          v-show="ActiveComponent=='Help' || ActiveComponent=='ChatHistory'"
        >
        </v-text-field>

        <div v-if="ActiveComponent=='UserLogin'">
          <div class="fs-24px text-white lh-1 mt-4 ">
            Let’s get started!
          </div>
          <p
            class="fs-14px font-weight-regular mt-2 mb-3"
          >
            Share your Email and Contact to begin the chat.
          </p>
          <span class=""> </span>
        </div>
      </v-card-title>
      <div>
        <v-card-text class="pa-0 overflow-auto">
          <v-main>
            <Suspense>
           <!-- <Transition name="fade" mode="out-in"> -->
            <template #default>
            <keep-alive :include="keepAliveComponents" :exclude="excludeComponents">
              <component
                :is="ActiveComponent"
                :key="ActiveComponent"
                :Search="search"
                @NavigateToOther="navigateToOther"
                @NavigateToHome="NavigateToHome"
                @CloseDialog="closeDialog"
                @GetChatHistory="getChatHistory"
                ref="componentRef"
                 @ContinueChat="continueChat"
              ></component>
            </keep-alive>
          </template>
            <template #fallback>
              <SkeletonLoader type="card-avatar, article, actions" ></SkeletonLoader>
            </template>
            </Suspense>
           <!-- </Transition> -->
          </v-main>
        </v-card-text>
        <v-bottom-navigation
          height="65"
          grow
          v-model="BottomActive"
          class="bottom-navigation"
          color="black"
          :active="ActiveComponent !='UserLogin' && ActiveComponent !='AIChatBot'"
        >
          <v-btn
            v-if="aiChatBotKeys?.IsHome"
            class="fs-14px overlay-transparent"
            @click="changeWidget('Home')"
             id="home"
            :class="ActiveComponent=='Home' ? 'text-primary v-btn--selected v-btn--active' : ''"
          >
          <span v-if="ActiveComponent != 'Home'" class="d-inline-block " style="height: 24px;">
            <span class="fs-22px TBS-Home mt-2px d-inline-block"></span>
          </span>
          <span v-else  class="d-inline-block" style="height: 24px;">
            <span class="fs-22px TBS-Home-Fill text-primary mt-2px d-inline-block">
              <span class="path1"></span>
              <span class="path2"></span>
            </span>
          </span>
        
            <span class="pt-1"
              :class="ActiveComponent=='Home' ? 'font-weight-medium text-primary' : 'font-weight-regular' "
              >Home
            </span>
          </v-btn>
          <v-btn
            v-if="aiChatBotKeys?.IsChat"
            class="fs-14px overlay-transparent"
            @click="changeWidget('AIChatBot')"
            id="aiChatBot"
            :class="ActiveComponent=='AIChatBot' ? 'text-black v-btn--selected v-btn--active' : ''"
          >
            <v-badge color="error" :content="NotificationCount" v-if="NotificationCount">
              <span class="fs-24px" :class="ActiveComponent !='AIChatBot' ? 'TBS-Message' :
              'TBS-Message-Fill  text-primary'" ></span>
            </v-badge>

            <span class="fs-24px" v-if="!NotificationCount" :class="ActiveComponent !='AIChatBot' ? 'TBS-Message' :
            'TBS-Message-Fill  text-primary'" ></span>

            <span class="pt-1"
              :class="ActiveComponent=='AIChatBot' ?'  text-primary' : 'font-weight-regular' "
              >Chat</span
            >
          </v-btn>

          <v-btn
            v-if="aiChatBotKeys?.IsHelp"
            class="fs-14px overlay-transparent"
            @click="changeWidget('Help')"
            id="help"
            :class="ActiveComponent=='Help' ? 'text-black v-btn--selected v-btn--active' : ''"
          >
          <span class="fs-24px" :class="ActiveComponent!='Help' ? 'TBS-Help' :
          'TBS-Help-Fill  text-primary'" ></span>

            <span class="pt-1"
              :class="ActiveComponent=='Help' ? 'font-weight-medium  text-primary' : 'font-weight-regular' "
              >Help</span
            >
          </v-btn>
          <v-btn
            v-if="aiChatBotKeys?.IsNews"
            class="fs-14px overlay-transparent"
            @click="changeWidget('News')"
            id="news"
            :class="ActiveComponent=='News' ? 'text-black v-btn--selected v-btn--active' : ''"
          >
          <span class="fs-24px" :class="ActiveComponent !='News' ? 'TBS-News' :
          'TBS-News-Fill'" ></span>

      

            <span class="pt-1"
              :class="ActiveComponent=='News' ? '' : 'font-weight-light' "
              >News</span
            >
          </v-btn>
          <v-btn
            v-if="aiChatBotKeys?.IsHistory && !IsNullorWhiteSpace(UserDetails?.EmailAddress)"
            class="fs-14px overlay-transparent"
            @click="changeWidget('ChatHistory')"
            id="chatHistory"
            :class="ActiveComponent=='ChatHistory' ? 'text-black v-btn--selected v-btn--active' : ''"
          >

          <!-- <span class="fs-24px" :class="ActiveComponent!='ChatHistory' ? 'TBS-History' :
          'TBS-History-Fill'" ></span> -->

            <!-- <v-icon class="fs-24px"
              >{{ActiveComponent=='ChatHistory' ? 'mdi-clipboard-text-clock' :
              'mdi-clipboard-text-clock-outline'}}</v-icon
            > -->

            <span v-if="ActiveComponent != 'ChatHistory'" class="d-inline-block" style="height: 24px;">
              <span class="fs-24px TBS-History "></span>
            </span>
            <span v-else  class="d-inline-block" style="height: 24px;">
              <span class="fs-24px TBS-History-Fill  text-primary">
                <span class="path1"></span>
                <span class="path2"></span>
                <span class="path3"></span>
              </span>
            </span>



            
            <span class="pt-1"
              :class="ActiveComponent=='ChatHistory' ? 'font-weight-medium  text-primary' : 'font-weight-regular' "
              >History</span
            >
          </v-btn>
        </v-bottom-navigation>
      </div>
      </div>
      <div v-else class="mt-2">
        <SkeletonLoader type="card-avatar, article, actions" ></SkeletonLoader>
      </div>
    </v-card>
  </v-sheet>
</v-layout>
